import { render, staticRenderFns } from "./StarterPackScenarioSections.vue?vue&type=template&id=027d53de&scoped=true"
import script from "./StarterPackScenarioSections.vue?vue&type=script&lang=js"
export * from "./StarterPackScenarioSections.vue?vue&type=script&lang=js"
import style0 from "./StarterPackScenarioSections.vue?vue&type=style&index=0&id=027d53de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027d53de",
  null
  
)

export default component.exports